import React from 'react'

const pageOne = {
    "id": "page-1",
    "sections": [
        {
            "id": "594d077a-e24f-4830-9f8a-3677fe52e5cd",
            "type": "message-header",
            "canDelete": false,
            "canMove": false,
            "props": {
                "title": "A Message",
                "caption": "AUG 8",
                "coverImageDescription" : null,
                "coverImage": {
                    "src": "https://firebasestorage.googleapis.com/v0/b/cb-prototype-4e3e7.appspot.com/o/assets%2Ftest-2b909c93-3c7b-44ca-99dd-5f7a841e95c4-UCLA%20-%20Message%202%20-%20Large.jpg?alt=media&token=f85804a3-a141-4849-a582-cfbc7734d34f",
                },
                "ariaHidden" : ['title', 'caption']
            }
        },
        {
            "id": "f6b9be08-9135-434b-9a13-59d99ef837ab",
            "type": "institution",
            "canDelete": false,
            "canMove": false,
            "props": {
                "title": "University of Virginia",
                "description" : "Example Image",
                "subtitle": "Virginia",
                "iconDescription" : "Logo - Square Avatar, Organization Name. City, State",
                "iconURL": "https://firebasestorage.googleapis.com/v0/b/cb-prototype-4e3e7.appspot.com/o/UVA%20-%20Logo%20-%20Square%20-%20Large.png?alt=media&token=8eed43e1-e049-4827-aff9-36de97543ee7",
                "ariaHidden" : ['icon', 'subtitle', 'description']
            }
        },
        {
            "id": "3f7de290-72a0-4252-829e-ceebf9c7ae80",
            "type": "paragraph",
            "canDelete": true,
            "canMove": true,
            "props": {
                "title": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
                "style": "body",
                "align": "left"
            }
        },
        {
            "id": "d725991b-0cd5-416a-8dbc-fd7a223f167d",
            "type": "image",
            "canDelete": true,
            "canMove": true,
            "props": {
                "footnote": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
                "image": {
                    "type": "image",
                    "placeholder": true,
                    "height": "350",
                    "contentMode": "cover",
                    "src": "https://firebasestorage.googleapis.com/v0/b/cb-prototype-4e3e7.appspot.com/o/assets%2Ftest-9176819c-7e4a-40db-bee0-2272ff2194d5-UCLA%20-%20Message%201%20-%20Large.jpg?alt=media&token=8a1cf387-6cd2-4e3a-be17-4a2bb4a77460",
                    "id": "image",
                    "accessibilityLabel": "Image",
                    "description" : "Example Image",
                    "sectionId": "d725991b-0cd5-416a-8dbc-fd7a223f167d",
                    "contrast": 0.35,
                    "title": "UCLA - Message 1 - Large"
                }
            }
        },
        {
            "id": "ee356e4a-0027-4379-ade3-cee83a4fc892",
            "type": "actionLearnMore",
            "canDelete": true,
            "canMove": true,
            "props": {
                "title": "Learn More",
                "url": "test.com",
                "actionDescription" : "Inquiry form link"
            }
        }
    ],
    "style": "light",
    "title": "New Page"
}

const pageTwo = {
    "id": "page-1",
    "sections": [
      {
        "id": "13272a80-2b3a-4af8-bf09-8ac26874c51f",
        "type": "message-header",
        "canDelete": false,
        "canMove": false,
        "props": {
          "title": "Another Message",
          "caption": "TUE 13 JUN, 6:24 PM",
          "coverImage": {
            "type": "image",
            "placeholder": true,
            "src": "https://firebasestorage.googleapis.com/v0/b/cb-prototype-4e3e7.appspot.com/o/assets%2Ftest-9176819c-7e4a-40db-bee0-2272ff2194d5-UCLA%20-%20Message%201%20-%20Large.jpg?alt=media&token=8a1cf387-6cd2-4e3a-be17-4a2bb4a77460",
            "height": "350",
            "contentMode": "cover",
            "id": "cover-image",
            "accessibilityLabel": "Icon",
            "sectionId": "13272a80-2b3a-4af8-bf09-8ac26874c51f",
            "contrast": 0.35,
            "title": "UCLA - Message 1 - Large"
          },
          "titleStyle": "titleHeader"
        }
      },
      {
        "id": "d305226e-0fc7-43e1-b642-234b629e6a8f",
        "type": "institution",
        "canDelete": false,
        "canMove": false,
        "props": {
          "title": "University of Virginia",
          "subtitle": "Virginia",
          "iconURL": "https://firebasestorage.googleapis.com/v0/b/cb-prototype-4e3e7.appspot.com/o/UVA%20-%20Logo%20-%20Square%20-%20Large.png?alt=media&token=8eed43e1-e049-4827-aff9-36de97543ee7"
        }
      },
      {
        "id": "bcf46776-d94c-4503-a030-aabd47ef760c",
        "type": "paragraph",
        "canDelete": true,
        "canMove": true,
        "props": {
          "title": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. \n\nDuis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
          "style": "body",
          "align": "left"
        }
      },
      {
        "id": "2248c51a-7b58-4664-8ed1-b04ae3cce18a",
        "type": "image",
        "canDelete": true,
        "canMove": true,
        "props": {
          "footnote": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
          "image": {
            "type": "image",
            "placeholder": true,
            "height": "350",
            "contentMode": "cover",
            "src": "https://firebasestorage.googleapis.com/v0/b/cb-prototype-4e3e7.appspot.com/o/assets%2Ftest-UCLA%20-%20Message%204%20-%20Large.jpg?alt=media&token=aea4984c-162e-43c9-9e3a-7beb008399cc",
            "id": "image",
            "accessibilityLabel": "Image",
            "description": "The alt text",
            "sectionId": "2248c51a-7b58-4664-8ed1-b04ae3cce18a",
            "contrast": 0,
            "saturation": 0,
            "title": "UCLA - Message 4 - Large"
          }
        }
      },
      {
        "id": "2d9cad04-a595-46b4-bcdf-7ad834c9ab4f",
        "type": "actionLearnMore",
        "canDelete": true,
        "canMove": true,
        "props": {
          "title": "Learn More",
          "url": "test.com"
        }
      }
    ],
    "style": "light",
    "title": "New Page"
  }

const pageThree = {
  "id": "page-1",
  "sections": [
    {
      "id": "13272a80-2b3a-4af8-bf09-8ac26874c51f",
      "type": "message-header",
      "canDelete": false,
      "canMove": false,
      "props": {
        "title": "More Messages\n",
        "caption": "AUG 8",
        "coverImage": {
          "type": "image",
          "placeholder": true,
          "src": "https://firebasestorage.googleapis.com/v0/b/cb-prototype-4e3e7.appspot.com/o/assets%2Ftest-44e5de03-12a3-4ea4-b905-edaba3b64547-UVA%20-%20Message%201%20-%20Large.jpg?alt=media&token=dcde83d5-b8ae-4db8-b0cd-2b5250505e39",
          "height": "350",
          "contentMode": "cover",
          "id": "cover-image",
          "accessibilityLabel": "Icon",
          "sectionId": "13272a80-2b3a-4af8-bf09-8ac26874c51f",
          "contrast": 0,
          "saturation": 0,
          "description": "Two students holding model planes",
          "title": "UVA - Message 1 - Large"
        },
        "titleStyle": "titleHeader"
      }
    },
    {
      "id": "d305226e-0fc7-43e1-b642-234b629e6a8f",
      "type": "institution",
      "canDelete": false,
      "canMove": false,
      "props": {
        "title": "University of Virginia",
        "subtitle": "Virginia",
        "iconURL": "https://firebasestorage.googleapis.com/v0/b/cb-prototype-4e3e7.appspot.com/o/UVA%20-%20Logo%20-%20Square%20-%20Large.png?alt=media&token=8eed43e1-e049-4827-aff9-36de97543ee7"
      }
    },
    {
      "id": "bcf46776-d94c-4503-a030-aabd47ef760c",
      "type": "paragraph",
      "canDelete": true,
      "canMove": true,
      "props": {
        "title": "Here's some content for this message's title. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. \n",
        "style": "body",
        "align": "left"
      }
    },
    {
      "id": "2248c51a-7b58-4664-8ed1-b04ae3cce18a",
      "type": "image",
      "canDelete": true,
      "canMove": true,
      "props": {
        "footnote": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
        "image": {
          "type": "image",
          "placeholder": true,
          "height": "350",
          "contentMode": "cover",
          "src": "https://firebasestorage.googleapis.com/v0/b/cb-prototype-4e3e7.appspot.com/o/assets%2Ftest-cf4531f8-3c6e-4f28-a054-d74675c53f33-%20Institution%20Image.png?alt=media&token=0f1c7235-ecc2-4f0c-a7f0-124a1c6cfa4f",
          "id": "image",
          "accessibilityLabel": "Image",
          "sectionId": "2248c51a-7b58-4664-8ed1-b04ae3cce18a",
          "contrast": 0,
          "saturation": 0,
          "description": "The alt text",
          "title": " Institution Image.png"
        }
      }
    },
    {
      "id": "2d9cad04-a595-46b4-bcdf-7ad834c9ab4f",
      "type": "actionLearnMore",
      "canDelete": true,
      "canMove": true,
      "props": {
        "title": "Learn More",
        "url": "test.com"
      }
    }
  ],
  "style": "light",
  "title": "New Page"
}

const examplePages = [pageOne, pageTwo, pageThree]
export { examplePages }